import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@box-shared/shared.module';
import { AccountRoutingModule } from './account-routing.module';
import { MarketWidgetModule } from '@box-market-widget/market-widget.module';
import { OrdersWidgetModule } from '@box-orders-widget/orders-widget.module';
import { SkeletonWidgetModule } from '@box-skeleton-widget/skeleton-widget.module';
import { ContestWidgetModule } from '@box-contest-widget/contest-widget.module';
import { RewardsWidgetModule } from '@box-rewards-widget/rewards-widget.module';
import { CouponWidgetModule } from '@box-coupon-widget/coupon-widget.module';

import * as Components from './components';
import * as Pages from './pages';

@NgModule({
  declarations: [
    Components.AccountAddressComponent,
    Components.AccountCardComponent,
    Components.AccountMenuComponent,
    Components.AccountHistoryOrdersComponent,
    Components.AccountFAQsPageNavComponent,
    Pages.AccountAddressesPage,
    Pages.AccountCardsPage,
    Pages.AccountCookiesPage,
    Pages.AccountContactPage,
    Pages.AccountDeleteProfilePage,
    Pages.AccountDetailsPage,
    Pages.AccountPage,
    Pages.AccountPersonalisationTermsPage,
    Pages.AccountPolicyTermsPage,
    Pages.AccountReferralPage,
    Pages.AccountTermsSubPage,
    Pages.AccountMarketCardsPage,
    Pages.AccountHistoryPage,
    Pages.AccountContestsPage,
    Pages.AccountSubmenuPage,
    Pages.AccountSettingsThemeComponent,
    Pages.AccountSettingsLanguageComponent,
    Pages.AccountUsefulLinksFAQPage,
    Pages.AccountTransparencyReportPage
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccountRoutingModule,
    OrdersWidgetModule,
    MarketWidgetModule,
    ContestWidgetModule,
    SkeletonWidgetModule,
    RewardsWidgetModule,
    CouponWidgetModule
  ]
})
export class AccountModule {}
